<template>
  <div class="main main--hasHeader main--hasFooter">
    <div class="customContainer">
      <h2 class="members__headline">{{ word_chg('ゲスト情報')}}</h2>
      <!-- {{ getMyGuests }} -->
      <div class="members-guest">
        <div  v-if="Object.keys(guests).length > 0">
          <div class="members-guest__wrapper" v-for="(guest, index) in guests" :key="guest">
            <h3 class="members-guest__headline">{{ word_chg('ゲスト')}}{{ (index + 1) }}</h3>
            <div class="members-guest__card d-flex">
              <ul class="members-guest__list">
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('姓')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.name_1" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('ミドルネーム')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.name_2" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('名')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.name_3" placeholder="">
                  </div>
                </li>
                <!-- <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">yomi</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.yomi_1" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">yomi</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.yomi_2" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">yomi</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.yomi_3" placeholder="">
                  </div>
                </li> -->
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('電話番号')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.tel_1" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center">
                  <soan class="item">{{ word_chg('携帯')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.mobile_1" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('〒')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.postal_cd" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('都道府県')}}</soan>
                  <div class="name members-member-form__data">
                    <bs-select
                      :options="pref_cd_list"
                      v-model="guest.pref_cd"
                      :null-option="false"
                      :class-param="'form-select-sm'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('市区町村')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.address_1" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('町域番地')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.address_2" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('建物名・号室')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="text" v-model="guest.address_3" placeholder="">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('生年月日')}}</soan>
                  <div class="name members-member-form__data">
                    <input type="date" v-model="guest.birth_date" placeholder="" :style="'color:' + birthdayColor(guest.birth_date) + ';'">
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('性別')}}</soan>
                  <div class="name members-member-form__data">
                    <bs-select
                      :options="sex_list"
                      v-model="guest.sex"
                      :null-option="false"
                      :id="'GuestSex_' + index"
                      :class-param="'form-select-sm'"
                      :name="'sex'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('RH')}}</soan>
                  <div class="name members-member-form__data">
                    <bs-select
                      :options="rh_list"
                      v-model="guest.blood_type_rh"
                      :null-option="false"
                      :id="'GuestBloodTypeRh_' + index"
                      :class-param="'form-select-sm'"
                      :name="'blood_type_rh'"
                      ></bs-select>
                  </div>
                </li>
                <li class="d-flex align-items-center" v-if="guest.form_disp_sw">
                  <soan class="item">{{ word_chg('血液型')}}</soan>
                  <div class="name members-member-form__data">
                    <bs-select
                      :options="abo_list"
                      v-model="guest.blood_type_abo"
                      :null-option="false"
                      :id="'GuestBloodTypeABO_' + index"
                      :class-param="'form-select-sm'"
                      :name="'blood_type_abo'"
                      ></bs-select>
                  </div>
                </li>
                <li class="">
                  <div class="text-center ">
                    <a @click="openForm(index)" v-if="!guest.form_disp_sw">{{ word_chg('詳細')}}</a>
                    <a @click="closeForm(index)" v-else>{{ word_chg('閉じる')}}</a>
                  </div>
                </li>
              </ul>
              <p class="members-guest__btn"><a class="button" @click="delGuest(index)">{{ word_chg('削除')}}</a></p>
            </div>
          </div>
        </div>
        <div v-else>
          {{ word_chg('ゲスト情報を登録してください。')}}
        </div>
        <div v-if="Object.keys(guests).length < max" class="">
          <p class="reserve05__addMember py-3">
              <a class="reserve05__addMemberLink" @click="addGuest()">＋ {{ word_chg('ゲストを追加登録する。')}}</a>
          </p>
        </div>
        <div v-else>
          <p>{{ word_chg('登録できるゲスト人数は')}}{{max }}{{ word_chg('人までです。')}}</p>
        </div>
        <div v-if="Object.keys(guests).length > 0" class="my-3">
          <p class="members-guest__add"><a class="button" @click="update">{{ word_chg('登録') }}</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import config from '../../../const'
import { mapState } from 'vuex'
import BsSelect from '../../atoms/BsSelect.vue'

export default {
  name: 'UserGuestView',
  data: function () {
      return {
        pref_cd_list: config.PREF_CD_LIST,
        max: 5,
        guestFrm: {
          id: 0,
          name_1: '',
          name_2: '',
          name_3: '',
          yomi_1: '',
          yomi_2: '',
          yomi_3: '',
          sex: 'unanswered',
          birth_date: '',
          postal_cd: '',
          pref_cd: '',
          address_1: '',
          address_2: '',
          address_3: '',
          tel_1: '',
          fax_1: '',
          mobile_1: '',
          blood_type_abo: 'unanswered',
          blood_type_rh: 'unanswered'
        },
        guests: [],
      }
  },
  components: {
    BsSelect,
  },
  methods: {
    delGuest(target){
      const tmp = this.guests;
      console.log('delGuest tmp =', tmp);
      tmp.splice(target, 1);
      console.log('delGuest tmp.splice =', tmp);
      this.guests = tmp;
      console.log('delGuest guestFrm =', this.guests);
    },
    addGuest(){
      const tmp = {};
      Object.assign(tmp, this.guestFrm);
      this.guests.push(tmp);
    },
    openForm(target){
      const tmp = this.guests;
      tmp[target].form_disp_sw = true;
      console.log('delGuest tmp =', tmp);
      console.log('delGuest tmp.splice =', tmp);
      this.guests = tmp;
      console.log('delGuest guestFrm =', this.guests);
    },
    closeForm(target){
      const tmp = this.guests;
      tmp[target].form_disp_sw = false;
      console.log('delGuest tmp =', tmp);
      console.log('delGuest tmp.splice =', tmp);
      this.guests = tmp;
      console.log('delGuest guestFrm =', this.guests);
    },
    update(){
      // alert('登録しました-demo-');
      const mydata = this.getMyData;
      delete mydata['login_pass'];
      mydata['guest_data'] = this.guests;
      console.log('component methods', mydata);
      return this.$store.dispatch('updateBasic', {data: mydata, target: 'member' })
          .then(() => {
            // // this.back()
            // alert('更新しました');
            alert(this.word_chg('更新しました。'));
            // this.alertMessage = this.btnLabel + 'しました';
            // this.alertClass = 'alert-success';
          })
          .catch(
            () => {
            err => Promise.reject(err);
            alert(this.word_chg('更新できませんでした。'));
              // this.alertMessage = this.btnLabel + 'できませんでした';
              // this.alertClass = 'alert-danger';
            }
          )
    },
    // login御
    loadUser(){
      const params = {};
      params['id'] = this.$store.state.auth.userId;
      console.log('params', params);
      return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
      .catch((err) => {
        console.log(err);
        Promise.reject(err)
      })
      .then(() => {})
      .finally(() => {});
    },
    loadSex(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'sex'})
                        .catch(err => Promise.reject(err))
                        .then(() => {})
                        .finally(() => {
                        })
    },
    loadBloodTypeABO(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'blood_type_abo'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete tax');
                            console.log('this', this.$store.state.apidata.sex);
                        })
                        .finally(() => {
                            console.log(' sex', this.$store.state.apidata.sex);
                        })

    },
    loadBloodTypeRH(){
            return this.$store.dispatch('fetchBasicLists', {data: {}, target: 'blood_type_rh'})
                        .catch(err => Promise.reject(err))
                        .then(() => {
                            console.log('loard complete tax');
                            console.log('this', this.$store.state.apidata.sex);
                        })
                        .finally(() => {
                            console.log(' sex', this.$store.state.apidata.sex);
                        })

    },
  },
  computed: {
    ...mapState({
      user: state => state.apidata.user,
      sex_type: state => state.apidata.sex,
      abo_type: state => state.apidata.blood_type_abo,
      rh_type: state => state.apidata.blood_type_rh,
    }),
    birthdayColor: function(){
      return function(date){
        if(date){
          return 'black';
        } else {
          return 'white';
        }
      }
    },
    sex_list: function(){
      const tmp = [];
      if(this.sex_type){
        Object.values(this.sex_type).forEach(sex => {
          tmp.push({
            key: sex.key,
            label: this.word_chg(sex.label)
          })
        });
      }
      return tmp;
    },
    abo_list: function(){
      // return this.abo_type;
      const tmp = [];
      if(this.abo_type){
        Object.values(this.abo_type).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },
    rh_list: function(){
      // return this.rh_type;
      const tmp = [];
      if(this.rh_type){
        Object.values(this.rh_type).forEach(flg => {
          tmp.push({
            key: flg.key,
            label: this.word_chg(flg.label)
          })
        });
      }
      return tmp;
    },

    getMyGuests: function(){
      if(this.getMyData.guest){
        return this.getMyData.guest;
      }
      return [];
    },
    getMyData: function(){
      const mydata = this.user.find((data) => {
        return data.id == this.$store.state.auth.userId;
      })
      return mydata;
    },
    axiosHeader: function(){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    },
  },
  created () {
    this.loadUser();
    this.loadSex();
    this.loadBloodTypeABO();
    this.loadBloodTypeRH();
    this.guests = this.getMyGuests.map(guest => {
      guest.form_disp_sw = false;
      return guest;
    });
  },
  mounted: function(){
  },

  props: {
  }

}
</script>
